/**
 * Created by valentin on 25/07/2017.
 */

import React from 'react'
import {polyglot} from '../../../index'

export default function BiggerScreenMessage () {
  return <div className='col-sm-12 col-md-8 small-screen-only'>
    <div className='panel panel-warning'>
      <div className='panel-heading'>
        <h3 className='panel-title'>{polyglot.t('commonFields.attention')}</h3>
      </div>
      <div className='panel-body'>{polyglot.t('staticText.biggerScreenMessage')}</div>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/common/BiggerScreenMessage/BiggerScreenMessage.js